import React, { useState } from "react";
import { Tab, Nav } from "react-bootstrap";
import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import ProjectList from "./ProjectList.js";
import { saveTrash } from "../../../store/slice/trashSlice.js";
import apiClient from "../../../apiClient/index.js";
import { GROUP_USER_LIST, PROJECT_LIST, TRASH_PROJECT_LIST } from "../../../apiClient/apiEndpoints.js";

const Projects = () => {
  const dispatch = useDispatch();
  const [tabActiveKey, setTabActiveKey] = useState("ongoing");
  const [ongoingList, setOngoingList] = useState([]);
  const [liveProjectList, setLiveProjectList] = useState([]);
  const [usersList, setUsersList] = useState([]);
  const [loading, setLoading] = useState(true);
  const userData = useSelector((state) => state.userSlice);
  const configData = useSelector((state) => state.configSlice);

  const handleChangeActiveKey = (selectedTab) => {
    setTabActiveKey(selectedTab);
  };

  const getProjectList = async () => {
    let data = await apiClient.get(`${configData.config.API_URL}${PROJECT_LIST}`);
    const userOwnedProjectIds = [];
    const sharedPublishedList = [];
    const sharedUnpublishedList = [];
    data.list.forEach((item) => userOwnedProjectIds.push(item.uuid));
    data.yetToStart.forEach((item) => userOwnedProjectIds.push(item.uuid));
    data.published.forEach((item) => userOwnedProjectIds.push(item.uuid));
    data?.shared.forEach((item) => {
      if (!userOwnedProjectIds.includes(item.uuid)) {
        if (item.published) {
          sharedPublishedList.push(item);
        } else {
          sharedUnpublishedList.push(item);
        }
      }
    });

    setOngoingList([...(data?.list || []), ...(data?.yetToStart || []), ...sharedUnpublishedList]);
    setLiveProjectList([...(data?.published || []), ...(sharedPublishedList || [])]);
  };

  const trashProjectList = async () => {
    let data = await apiClient.get(`${configData.config.API_URL}${TRASH_PROJECT_LIST}`);
    dispatch(saveTrash(data));
  };

  const groupUsersList = async () => {
    try {
      let data = await apiClient.get(`${configData.config.UNO_URL}${GROUP_USER_LIST}/${userData.user.group.uuid}`);
      setUsersList(data);
    } catch (error) {
      console.log(error);
    }
  };

  const initializePage = async () => {
    setLoading(true);
    await Promise.all([trashProjectList(), getProjectList(), groupUsersList()]);
    setLoading(false);
  };

  useEffect(() => {
    initializePage();
  }, []);

  return (
    <>
      <Tab.Container id="my-tabs" activeKey={tabActiveKey} onSelect={handleChangeActiveKey}>
        <Nav className="tabsproduct updated toptab cc" variant="tabs">
          <Nav.Item>
            <Nav.Link eventKey="ongoing">Ongoing</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="liveProject">Live Project</Nav.Link>
          </Nav.Item>
        </Nav>

        <div className="container-fluid p-4 pt-5 bg-grey-main">
          <Tab.Content>
            <Tab.Pane eventKey="ongoing">
              <ProjectList
                list={ongoingList}
                listLoading={loading}
                trashProjectList={trashProjectList}
                getProjectList={getProjectList}
                showDashboard={false}
                usersList={usersList}
              />
            </Tab.Pane>
            <Tab.Pane eventKey="liveProject">
              <ProjectList
                list={liveProjectList}
                listLoading={loading}
                trashProjectList={trashProjectList}
                getProjectList={getProjectList}
                showDashboard={false}
                usersList={usersList}
              />
            </Tab.Pane>
          </Tab.Content>
        </div>
      </Tab.Container>
    </>
  );
};
export default Projects;
